import type { HTMLAttributes, RefObject } from 'react';
import type { PaginationData } from '..';

export type BreederReviewCategory = 'humanContact' | 'cleaning' | 'followup' | 'wellBeing';

export interface BreederReviewListData {
  mode: 'list' | 'create' | 'edit';
  items: BreederReviewItemData[];
  categoryAverage?: Partial<Record<BreederReviewCategory, number>>;
  amount?: number;
  average?: number;
  loading?: boolean;
  pagination?: PaginationData;
  canAnswerReviews?: boolean;
  onEditClick?: (id: number) => void;
  onAnswerClick?: (id: number) => void;
  onCancelClick?: () => void;
  updateLoading?: boolean;
  activeReviewId?: number;
  reviewsRef?: RefObject<HTMLDivElement>;
}

export interface BreederReviewItemData {
  id?: number;
  name?: string;
  image?: string;
  description?: string;
  average?: number;
  date?: string;
  type?: string;
  verified?: boolean;
  answer?: BreederReviewAnswerItemData;
}
export interface BreederReviewAnswerItemData {
  content: string;
  date: string;
  breederName?: string;
  breederPic?: string;
}
export interface BreederReviewsFormValues {
  content?: string;
}

export interface BreederReviewListProps
  extends HTMLAttributes<HTMLDivElement>,
    BreederReviewListData {}
